<template>
  <div class="content">
    <h2 class="text-2xl font-bold mb-4">Welcome to Spin the Names</h2>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">What is Spin the Names?</h3>
      <p>Spin the Names is a free interactive tool that helps you make random selections in a fun and engaging
        way. Simply add names, options, or choices to the wheel, give it a spin, and let the wheel decide!</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Who created this app?</h3>
      <p>Spin the Names is developed and maintained by an independent developer. It began as a fork of the
        momander/wheel-spinner project and has been enhanced for performance and presentation. While not backed by a
        large company, the project is built with professional standards and a focus on a reliable, enjoyable experience.
        For questions or feedback, contact us at ash@spinthenames.com.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">What can I use this app for?</h3>
      <p>Spin the Names is versatile and can be used for many purposes:</p>
      <ul class="list-disc ml-6 mt-2">
        <li>Randomly selecting students in a classroom</li>
        <li>Choosing winners for contests or giveaways</li>
        <li>Making decisions when you're undecided</li>
        <li>Creating interactive games at parties or events</li>
        <li>Fairly distributing tasks or responsibilities</li>
        <li>Adding an element of fun to team-building activities</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Is it free to use?</h3>
      <p>Yes! Spin the Names is completely free to use with all its core features. The app is supported by
        non-intrusive advertisements, but these don't limit your access to any functionality. The app is designed
        to keep random selection tools accessible to everyone!</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Do I need to create an account?</h3>
      <p>No account is required to use the basic features of Spin the Names. However, creating a free account
        allows you to save your wheels for future use, access them from any device, and share them with others
        more easily.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">How do I get started?</h3>
      <p>Getting started is simple:</p>
      <ol class="list-decimal ml-6 mt-2">
        <li>Add names or options to the wheel using the input panel</li>
        <li>Customize your wheel's appearance if desired</li>
        <li>Click the spin button or use the spacebar to spin the wheel</li>
        <li>See your random result when the wheel stops!</li>
      </ol>
    </div>

    <p class="mt-8 text-sm"><a href="#top" class="text-blue-500 hover:underline">Back to top</a></p>
  </div>
</template>

<script setup>
import '@components/ui/faq/faqStyles.css';
</script>
